<script>
import tools from '../../tools/tools'
import RelatorioHTML from '../../utils/RelatorioHTML'
import ProdutoPesquisa from '../pesquisa/ProdutoPesquisa'
import CecInputData from '../../components/Cec/CecInputData'
import ProducaoFormulaProcessoFormulaDropDown from '../producao/producao-formula-processo/ProducaoFormulaProcessoFormulaDropDown'

export default {
  components: {
    ProdutoPesquisa,
    CecInputData,
    ProducaoFormulaProcessoFormulaDropDown
  },
  data: function() {
    return {
      loading: false,
      tipoRelatorio: '1',
      DT1: tools.getFirstDayOfMonth(),
      DT2: tools.getDataAtual(),
      PRODUTO_ID: null,
      MATERIA_PRIMA_ID: null,
      FORMULA_ID: null,
      SITUACAO: '',
      LOTE: '',
      opcoesRelatorio: [
        { value: '1', text: 'Listagem de Produção (Geral - HTML Premium)' },
        { value: '2', text: 'Relatório Analítico de Consumo (Componentes - HTML Premium)' },
        { value: '3', text: 'Balanço de Perdas e Rendimento (HTML Premium)' },
        { value: '4', text: 'Extrato de Utilização de Matéria-Prima (Rastreabilidade - HTML Premium)' }
      ],
      opcoesSituacao: [
        { value: '', text: 'Todas as Situações' },
        { value: 'L', text: 'Em Lançamento' },
        { value: 'F', text: 'Finalizado' },
        { value: 'C', text: 'Cancelado' }
      ]
    }
  },
  computed: {
    isDark: function() {
      return this.$store.state.controle.isDark
    }
  },
  methods: {
    imprimir: async function() {
      if (this.loading) return
      this.loading = true
      this.$store.commit('controle/setAguardando', true)

      try {
        const params = {
          dt1: this.DT1,
          dt2: this.DT2,
          produtoId: this.PRODUTO_ID || '',
          materiaPrimaId: this.MATERIA_PRIMA_ID || '',
          formulaId: this.FORMULA_ID || '',
          situacao: this.SITUACAO || '',
          lote: this.LOTE || '',
          tipoData: 'P',
          analitico: ['2', '4'].includes(this.tipoRelatorio) ? '1' : '0'
        }

        const response = await this.$http.get('/api/protected/producao/getRelatorioProducaoHtml', { params })
        const data = response.data

        if (!data || data.length === 0) {
          tools.exibirMensagem(this.$store, 'Nenhum dado encontrado para os filtros selecionados', 'warning')
          return
        }

        if (this.tipoRelatorio === '1') this.gerarRelatorioGeral(data)
        else if (this.tipoRelatorio === '2') this.gerarRelatorioAnalitico(data)
        else if (this.tipoRelatorio === '3') this.gerarRelatorioRendimento(data)
        else if (this.tipoRelatorio === '4') this.gerarRelatorioAnalitico(data)

      } catch (error) {
        tools.exibirMensagem(this.$store, 'Erro ao gerar relatório', 'danger', error)
      } finally {
        this.loading = false
        this.$store.commit('controle/setAguardando', false)
      }
    },

    getCommonHeader: function(titulo) {
      const nomeUsuario = window.localStorage.getItem('nomeusuario') || window.localStorage.getItem('login') || 'sistema'
      const nomeEmpresa = window.localStorage.getItem('nomeempresa') || 'CECWEB'
      const dataHora = new Date().toLocaleString('pt-BR')
      return `
        <div class="report-header">
          <div class="report-header-top">
            <div><strong>${nomeEmpresa}</strong></div>
            <div><strong>Usuário:</strong> ${nomeUsuario}</div>
          </div>
          <div class="report-header-title">${titulo}</div>
          <div class="report-header-sub">
            <div><strong>Período:</strong> ${this.DT1} até ${this.DT2}</div>
            <div><strong>Emitido em:</strong> ${dataHora}</div>
          </div>
        </div>
      `
    },

    getCommonFooter: function(totalItens) {
      const nomeUsuario = window.localStorage.getItem('nomeusuario') || window.localStorage.getItem('login') || 'sistema'
      const dataHora = new Date().toLocaleString('pt-BR')
      return `
        <div class="report-footer">
          <div>Impresso em: ${dataHora}</div>
          <div>Qtd. registros: ${totalItens}</div>
          <div>Usuário: ${nomeUsuario}</div>
        </div>
      `
    },

    getCommonStyles: function(landscape) {
      const orientation = landscape ? 'landscape' : 'portrait'
      return `
        <style>
          @page { 
            size: A4 ${orientation}; 
            margin: 15mm 12mm 12mm 18mm; 
          }
          body { 
            font-family: Arial, Helvetica, sans-serif; 
            margin: 0; 
            padding: 0;
            color: #111; 
            -webkit-print-color-adjust: exact; 
            print-color-adjust: exact; 
          }
          .report-container {
            width: 99%;
            margin: 0 auto;
          }
          .report-header { 
            border: 1px solid #2f2f2f; 
            margin-bottom: 10px; 
            width: 100%; 
            box-sizing: border-box; 
          }
          .report-header-top, .report-header-sub { 
            display: flex; 
            justify-content: space-between; 
            padding: 4px 8px; 
            font-size: 10px; 
            border-bottom: 1px solid #2f2f2f; 
          }
          .report-header-title { 
            padding: 6px 8px; 
            font-size: 12px; 
            font-weight: 700; 
            text-align: center; 
            text-transform: uppercase; 
            border-bottom: 1px solid #2f2f2f; 
          }
          .grid-main { 
            width: 100%; 
            border-collapse: collapse; 
            margin-top: 5px; 
            table-layout: fixed; 
          }
          .grid-main th, .grid-main td { 
            border: 1px solid #2f2f2f; 
            padding: 4px 6px; 
            font-size: 10px; 
            vertical-align: middle; 
            word-wrap: break-word; 
          }
          .grid-main th { 
            background: #f2f2f2; 
            text-align: left; 
            font-weight: 700; 
            text-transform: uppercase; 
          }
          .badge { 
            padding: 2px 4px; 
            border-radius: 3px; 
            color: #fff; 
            font-weight: bold; 
            text-transform: uppercase; 
            font-size: 8px; 
          }
          .badge-f { background: #28a745; }
          .badge-l { background: #007bff; }
          .badge-c { background: #dc3545; }
          .report-footer { 
            position: fixed; 
            left: 18mm; 
            right: 12mm; 
            bottom: 5mm; 
            display: flex; 
            justify-content: space-between; 
            font-size: 9px; 
            border-top: 1px solid #2f2f2f; 
            padding-top: 4px; 
            background: #fff; 
          }
          @media print { 
            body { margin: 0; padding: 0; }
            .report-footer { bottom: 0; }
          }
        </style>
      `
    },

    gerarRelatorioGeral: function(data) {
      const self = this
      let rows = data.map(function(p) {
        const rend = p.QUANT_PREVISTA > 0 ? (p.QUANT_PRODUZIDA / p.QUANT_PREVISTA) * 100 : 100
        return `
          <tr>
            <td align="center">${p.ID}</td>
            <td align="center">${tools.formatarDataBR(p.DATA_PROCESSO)}</td>
            <td>${p.PRODUTO_ID} - ${p.PRODUTO_DESCRICAO}</td>
            <td>${p.FORMULA_DESCRICAO}</td>
            <td align="center">${p.LOTE || '-'}</td>
            <td align="right">${tools.formatarQuantidade(p.QUANT_PREVISTA)}</td>
            <td align="right">${tools.formatarQuantidade(p.QUANT_PRODUZIDA)}</td>
            <td align="right">${tools.formatarQuantidade(rend)}%</td>
            <td align="center"><span class="badge badge-${p.SITUACAO.toLowerCase()}">${p.SITUACAO_LABEL}</span></td>
          </tr>
        `
      }).join('')

      let html = `
        <!doctype html>
        <html lang="pt-BR">
        <head>
          <meta charset="utf-8">
          <title>Listagem de Produção</title>
          ${this.getCommonStyles(true)}
        </head>
        <body>
          <div class="report-container">
            ${this.getCommonHeader('RELATÓRIO DE PRODUÇÃO POR FÓRMULA - LISTAGEM GERAL')}
            <table class="grid-main">
              <thead>
                <tr>
                  <th width="40">ID</th><th width="70">DATA</th><th>PRODUTO FINAL</th><th width="150">FÓRMULA</th>
                  <th width="80">LOTE</th><th width="70" align="right">QTD PREV.</th><th width="70" align="right">QTD REAL</th>
                  <th width="60" align="right">REND. %</th><th width="70">SITUAÇÃO</th>
                </tr>
              </thead>
              <tbody>${rows}</tbody>
            </table>
            ${this.getCommonFooter(data.length)}
          </div>
        </body>
        </html>
      `
      RelatorioHTML.imprimir(html, 'Relatório de Produção', 'A4', 'landscape')
    },

    gerarRelatorioAnalitico: function(data) {
      const self = this
      let content = data.map(function(p) {
        let itemsRows = (p.ITENS || []).map(function(i) {
          return `
            <tr>
              <td>${i.PRODUTO_ID} - ${i.PRODUTO_DESCRICAO}</td>
              <td align="right">${tools.formatarQuantidade(i.QUANT_PREVISTA)}</td>
              <td align="right" style="font-weight: bold;">${tools.formatarQuantidade(i.QUANT_APONTADA)}</td>
              <td style="font-size: 7px;">${i.LOTES_CONSUMIDOS || '-'}</td>
            </tr>
          `
        }).join('')

        return `
          <div style="margin-top: 15px; border: 1px solid #000;">
            <div style="background: #eee; padding: 5px; font-weight: bold; border-bottom: 1px solid #000;">
              PROCESSO: ${p.ID} | DATA: ${tools.formatarDataBR(p.DATA_PROCESSO)} | PRODUTO: ${p.PRODUTO_DESCRICAO} | LOTE: ${p.LOTE}
            </div>
            <table class="grid-main" style="margin-top: 0;">
              <thead>
                <tr style="background:#fafafa">
                  <th>COMPONENTE / MATÉRIA-PRIMA</th><th width="80" align="right">PREVISTO</th>
                  <th width="80" align="right">CONSUMIDO</th><th width="120">LOTES UTILIZADOS</th>
                </tr>
              </thead>
              <tbody>${itemsRows}</tbody>
            </table>
          </div>
        `
      }).join('')

      let html = `
        <!doctype html>
        <html lang="pt-BR">
        <head>
          <meta charset="utf-8">
          <title>Analítico de Consumo</title>
          ${this.getCommonStyles(false)}
        </head>
        <body>
          <div class="report-container">
            ${this.getCommonHeader('RELATÓRIO ANALÍTICO DE CONSUMO DE PRODUÇÃO')}
            ${content}
            ${this.getCommonFooter(data.length)}
          </div>
        </body>
        </html>
      `
      RelatorioHTML.imprimir(html, 'Analítico de Consumo', 'A4', 'portrait')
    },

    gerarRelatorioRendimento: function(data) {
      const self = this
      let rows = data.map(function(p) {
        const rend = p.QUANT_PREVISTA > 0 ? (p.QUANT_PRODUZIDA / p.QUANT_PREVISTA) * 100 : 100
        const corRend = rend < 95 ? 'color: red; font-weight: bold;' : ''
        return `
          <tr>
            <td align="center">${p.ID}</td>
            <td>${p.PRODUTO_DESCRICAO}<br/><small>${p.FORMULA_DESCRICAO}</small></td>
            <td align="right">${tools.formatarQuantidade(p.QUANT_PREVISTA)}</td>
            <td align="right" style="font-weight: bold;">${tools.formatarQuantidade(p.QUANT_PRODUZIDA)}</td>
            <td align="right" style="color: #d33;">${tools.formatarQuantidade(p.QUANT_PERDA)}</td>
            <td align="right" style="color: #28a745;">${tools.formatarQuantidade(p.QUANT_SOBRA)}</td>
            <td align="right" style="${corRend}">${tools.formatarQuantidade(rend)}%</td>
          </tr>
        `
      }).join('')

      let html = `
        <!doctype html>
        <html lang="pt-BR">
        <head>
          <meta charset="utf-8">
          <title>Balanço de Rendimento</title>
          ${this.getCommonStyles(true)}
        </head>
        <body>
          <div class="report-container">
            ${this.getCommonHeader('RELATÓRIO DE BALANÇO DE RENDIMENTO E PERDAS')}
            <table class="grid-main">
              <thead>
                <tr>
                  <th width="40">OP</th><th>PRODUTO / FÓRMULA</th><th width="80" align="right">QTD PREV.</th>
                  <th width="80" align="right">PRODUZIDA</th><th width="80" align="right">PERDA</th>
                  <th width="80" align="right">SOBRA</th><th width="70" align="right">REND. %</th>
                </tr>
              </thead>
              <tbody>${rows}</tbody>
            </table>
            ${this.getCommonFooter(data.length)}
          </div>
        </body>
        </html>
      `
      RelatorioHTML.imprimir(html, 'Balanço de Rendimento', 'A4', 'landscape')
    }
  }
}
</script>

<template>
  <div class="animated fadeIn">
    <form @submit.prevent="imprimir">
      <b-row>
        <b-col sm="12">
          <b-card id="card-relatorio" 
            :bg-variant="isDark ? 'dark' : 'white'" 
            :text-variant="isDark ? 'light' : 'dark'"
            :footer-bg-variant="isDark ? 'dark' : 'light'">
            
            <div class="p-4 d-flex align-items-center justify-content-between" 
                 :class="isDark ? 'bg-secondary-soft' : 'bg-primary-soft'">
              <div>
                <h4 class="mb-1 font-weight-bold" :class="isDark ? 'text-white' : 'text-primary'">
                  <i class='fa fa-industry mr-2'></i>Relatório de Produção por Fórmula
                </h4>
                <span class="text-muted d-block">Acompanhe seus processos de fabricação, rendimentos e consumo de matéria-prima.</span>
              </div>
            </div>

            <div class="section-container mb-4 mt-4" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-list-alt mr-2"></i>Tipo de Relatório</h6>
              <b-row>
                <b-col sm="12">
                  <b-form-group label-for="tipoRelatorio" description="Selecione o modelo de relatório desejado.">
                    <b-form-select 
                      id="tipoRelatorio"
                      v-model="tipoRelatorio"
                      :options="opcoesRelatorio"
                      :plain="true"
                      class="form-control-lg select-premium"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <div class="section-container mb-4" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-filter mr-2"></i>Filtros de Identificação</h6>
              <b-row>
                <b-col md="6" sm="12">
                  <b-form-group label="Produto Final">
                    <produto-pesquisa
                      @retornaId="PRODUTO_ID = $event"
                      :idInicial="PRODUTO_ID"
                      place="Filtrar por Produto Final"
                      label=""
                      ref="produtoPesquisa">
                    </produto-pesquisa>
                  </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                  <b-form-group label="Matéria-Prima / Insumo">
                    <produto-pesquisa
                      @retornaId="MATERIA_PRIMA_ID = $event"
                      :idInicial="MATERIA_PRIMA_ID"
                      place="Filtrar por Insumo Utilizado"
                      label=""
                      ref="materiaPrimaPesquisa">
                    </produto-pesquisa>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6" sm="12">
                  <b-form-group label="Fórmula">
                    <producao-formula-processo-formula-drop-down
                      v-model="FORMULA_ID"
                      placeholder="Todas as fórmulas"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="3" sm="6">
                  <b-form-group label="Situação">
                    <b-form-select 
                      v-model="SITUACAO"
                      :options="opcoesSituacao"
                      :plain="true"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="3" sm="6">
                  <b-form-group label="Lote Final">
                    <b-form-input 
                      v-model="LOTE"
                      placeholder="Filtrar por Lote"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <div class="section-container mb-4" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-calendar mr-2"></i>Período do Processo</h6>
              <b-row>
                <b-col md="4" sm="6">
                  <b-form-group label="Data Início">
                    <cec-input-data v-model="DT1" />
                  </b-form-group>
                </b-col>
                <b-col md="4" sm="6">
                  <b-form-group label="Data Fim">
                    <cec-input-data v-model="DT2" />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <div slot="footer" class="p-3">
              <b-row class="justify-content-center">
                <b-col md="4" sm="12">
                  <b-button 
                    type="submit" 
                    variant="primary" 
                    block 
                    size="lg" 
                    class="btn-premium shadow"
                    :disabled="loading">
                    <i class="fa fa-print mr-2"></i>{{ loading ? 'PROCESSANDO...' : 'GERAR RELATÓRIO' }}
                  </b-button>
                </b-col>
              </b-row>
            </div>

          </b-card>
        </b-col>
      </b-row>
    </form>
  </div>
</template>

<style scoped>
.bg-primary-soft { background-color: #e8f0fe; }
.bg-secondary-soft { background-color: #3e444a; }
.select-premium {
  border: 1.5px solid #ced4da;
  border-radius: 8px;
  transition: all 0.2s;
  background-color: #fff;
}
.select-premium:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.15);
}
.section-container {
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 20px;
  background: #fdfdfd;
  position: relative;
}
.section-container.dark-mode {
  background: #2c2c2c;
  border-color: #444;
}
.section-title {
  position: absolute;
  top: -12px;
  left: 20px;
  background: #fff;
  padding: 0 10px;
  font-weight: bold;
  color: #666;
  font-size: 0.85rem;
  text-transform: uppercase;
}
.section-title.dark-mode {
  background: #2c2c2c;
  color: #aaa;
}
.btn-premium {
  border-radius: 10px;
  font-weight: bold;
  letter-spacing: 0.5px;
  transition: all 0.3s;
}
.btn-premium:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 123, 255, 0.3);
}
</style>



// WEBPACK FOOTER //
// src/views/relatorios/RelProducaoFormula.vue